import * as tags from './tags';

export const tagTypes = Object.values(tags);

export type TagType = (typeof tagTypes)[number];

export type Tags =
  | TagType[]
  | {
      type: TagType;
      id?: string | number;
    }[];
